<template>
	<div>
		<case-form :schema="schemaShared" class="mt6" />

		<div class="xs-12 fs4 fw7 mb2 mt6">Current Year</div>
		<case-form :schema="schemaCurrentYear" />

		<div class="xs-12 fs4 fw7 mb2 mt6">Last Year</div>
		<case-form :schema="schemaLastYear" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schemaShared() {
			return [
				{
					label: `Is Income statement shared?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementIsShared`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementIsShared`
						},
						createOptions: {
							type: `incomeStatementIsShared`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>If "yes" answer questions below</div>`
					},
					bindTo: ""
				},
				{
					label: `Shared with (Indiciate Relationship):`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSharedWith`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSharedWith`
						},
						createOptions: {
							type: `incomeStatementSharedWith`,
							dataType: "string"
						}
					}
				},
				{
					label: `Portion earned by Client (%)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSharedRatio`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSharedRatio`
						},
						createOptions: {
							type: `incomeStatementSharedRatio`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaCurrentYear() {
			return [
				{
					label: `Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDate`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryDate`
						},
						createOptions: {
							type: `incomeStatementSalaryDate`,
							dataType: "date"
						}
					}
				},
				{
					label: `Salary (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSalary`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalary`
						},
						createOptions: {
							type: `incomeStatementSalary`,
							dataType: "number"
						}
					}
				},
				{
					label: `Bonus (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementBonus`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementBonus`
						},
						createOptions: {
							type: `incomeStatementBonus`,
							dataType: "number"
						}
					}
				},
				{
					label: `Interest (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementInterest`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementInterest`
						},
						createOptions: {
							type: `incomeStatementInterest`,
							dataType: "number"
						}
					}
				},
				{
					label: `Dividends (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDividends`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementDividends`
						},
						createOptions: {
							type: `incomeStatementDividends`,
							dataType: "number"
						}
					}
				},
				{
					label: `Rent (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementRent`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementRent`
						},
						createOptions: {
							type: `incomeStatementRent`,
							dataType: "number"
						}
					}
				},
				{
					label: `Other (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementOther`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementOther`
						},
						createOptions: {
							type: `incomeStatementOther`,
							dataType: "number"
						}
					}
				},
				{
					label: `Total Income`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementTotal`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementTotal`
						},
						createOptions: {
							type: `incomeStatementTotal`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaLastYear() {
			return [
				{
					label: `Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDateLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryDateLastYear`
						},
						createOptions: {
							type: `incomeStatementSalaryDateLastYear`,
							dataType: "date"
						}
					}
				},
				{
					label: `Salary (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSalaryLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryLastYear`
						},
						createOptions: {
							type: `incomeStatementSalaryLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Bonus (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementBonusLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementBonusLastYear`
						},
						createOptions: {
							type: `incomeStatementBonusLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Interest (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementInterestLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementInterestLastYear`
						},
						createOptions: {
							type: `incomeStatementInterestLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Dividends (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDividendsLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementDividendsLastYear`
						},
						createOptions: {
							type: `incomeStatementDividendsLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Rent (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementRentLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementRentLastYear`
						},
						createOptions: {
							type: `incomeStatementRentLastYear`,
							dataType: "number"
						}
					}
				},
				{
					label: `Other (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementOtherLastYear`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementOtherLastYear`
						},
						createOptions: {
							type: `incomeStatementOtherLastYear`,
							dataType: "number"
						}
					}
				}
			]
		}
	}
}
</script>
